export enum BimModelLotEnum {
  ARCHITECTURE = "ARCHITECTURE",
  STRUCTURE = "STRUCTURE",
  TECHNIQUE_CVCP = "TECHNIQUE_CVCP",
  VOIRIE_RESEAUX_DIVERS = "VOIRIE_RESEAUX_DIVERS",
}
